import styled from 'styled-components';
import { PaperContent } from 'view/layout/paper';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line rulesdir/no-styled-export
export const AnnouncementInnerContainer = styled(PaperContent)`
    /* Reset top padding from the paper content. */
    padding-top: 0;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const AdvertiseUnifiedHelpRequestCreateWrapper = styled.div`
    margin-left: ${token('space.300', '24px')};
    margin-right: ${token('space.300', '24px')};
`;
